import { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import {
    getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, settings, getLanguageObj, getResponse, setDateTimeFormatGlobal
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';
import { LlmModelClass } from '../../classes/ai/LlmModelClass';
import { LargeLanguageModelClass } from '../../classes/ai/largeLanguageModelClass';
import { LlmModelService } from '../../services/largeLanguageModel/LlmModelService';

const { html, icons, images, messages, labels, firebase } = settings;
const { fields: dbFields } = firebase?.firestore;

const currentMethod = 'LlmModelAddEdit - function';

export default function LlmModelAddEdit({
    $ = {},
    auth = AuthContextType,
    processValues = { id: '', description: '', dtId: '', dtRowId: 0, type: 0, subMethod: '' },
    setProcessValues = () => { },
    showModal = false,
    setShowModal = () => { },
    llmModel = LlmModelClass?.getClass(),
    setLlmModel = () => { },
    llmModels = [LlmModelClass?.getClass()],
    setLlmModels = () => { },
    largeLanguageModel = LargeLanguageModelClass?.getClass(),
    setLargeLanguageModel = () => { },
    setDtRow = ({
        data = LlmModelClass?.getClass(),
        subMethod = '',
    } = {}) => { },
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [errors, setErrors] = useState({
        largeLanguageModel: '',
        code: '',
        description: '',
        created: '',
    });
    const [process, setProcess] = useState({ showLoading: false, save: false, });
    const isMount = useRef(true);

    const dateTimeFormat = `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`;
    const controls = {
        pickers: {
            created: {
                id: 'pickerCreatedId',
            }
        },
        inputs: {
            created: {
                id: 'inputCreatedId',
            }
        },
    }
    //#endregion variables

    //#region methods
    const llmModelAddEdit = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'llmModelAddEdit';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            let llmModel_ = response?.result || {};
            const data_ = { ...llmModel_, languageId: languageObj?.id };

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            if (processValues?.type === 0) {
                response = await LlmModelService?.create({
                    data: data_,
                    token: auth?.account?.tokenVzLaML?.token,
                    subMethod: currentMethod
                });
            } else if (processValues?.type === 1) {
                response = await LlmModelService?.update({
                    id: processValues?.id,
                    data: data_,
                    token: auth?.account?.tokenVzLaML?.token,
                    subMethod: currentMethod
                });

            }
            if (!response?.isSuccess || response?.isWarning) return;

            llmModel_ = response?.result || {};

            const dtRow = setDtRow({
                data: llmModel_,
                subMethod: currentMethod,
            })?.result;

            if (processValues?.type === 0) {
                $(`#${processValues?.dtId}`).DataTable().row.add(dtRow).draw();
                setLlmModels(prev => [...prev, llmModel_]);
            } else if (processValues?.type === 1) {
                $(`#${processValues?.dtId}`).DataTable().row(processValues?.dtRowId).data(dtRow).draw();
                setLlmModels(prev => prev.map((model) => model?.id === processValues?.id ? llmModel_ : model));
            }

            response.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if(response?.isSuccess && !response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const errors_ = { largeLanguageModel: '', code: '', description: '', created: '' };
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];

            const dateTime = $(`#${controls?.pickers?.created?.id}`)?.datetimepicker('date')?._d;
            const createdObj = moment(dateTime, dateTimeFormat);

            if (isUndNullEmpNew({ data: llmModel?.llmId, subMethod: currentMethod })?.result ||
                isUndNullEmpNew({ data: llmModel?.userId, subMethod: currentMethod })?.result) {
                errors_.largeLanguageModel = thisFieldRequired;
                response = getResponse({ type: 1 });
                console.log(`llmId or userId. ${thisFieldRequired}`);
            }

            if (isUndNullEmpNew({ data: llmModel?.code, subMethod: currentMethod })?.result) {
                errors_.code = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: llmModel?.description, subMethod: currentMethod })?.result) {
                errors_.description = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: llmModel?.created, subMethod: currentMethod })?.result || !createdObj.isValid()) {
                errors_.created = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            setErrors(errors_);
            if (!response?.isWarning) {
                const llmModel_ = { ...llmModel, created: createdObj?._d?.toISOString() };
                setLlmModel(llmModel);
                response.result = llmModel_;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setDateInControl = ({
        date = {},
        created = {},
        processType_ = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            let dateTime = '';
            const dateFormat = {
                date: languageObj?.format?.date?.f1,
                time: languageObj?.format?.time?.type
            };

            dateTime = setDateTimeFormatGlobal({
                date: created || date,
                type: dateFormat?.date,
                format: dateFormat?.time,
                addTime: false,
                withSeconds: false,
                subMethod: currentMethod
            })?.result;

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${controls?.pickers?.created?.id}`)?.datetimepicker('options', {
                date: dateTime,
                default: false,
                timepicker: true,
                format: dateTimeFormat,
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            response = setDateInControl({
                date: new Date(),
                created: llmModel?.created,
                processType_: 0,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad', });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} backdrop='static' centered contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='llmModel' src={images?.icons?.llmModel} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.model?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${processValues?.type === 0 ? 'badge-info' : 'badge-warning'} text-dark`}
                            style={html?.badges?.micro}>
                            {processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => llmModelAddEdit({ e: e, subMethod: 'onSubmit - form' })}>
                <Modal.Body className='px-4 pt-2'>
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.largeLanguageModel?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.brain} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.largeLanguageModel?.[languageObj?.id]}
                                type='text'
                                placeholder={labels?.largeLanguageModel?.[languageObj?.id]}
                                readOnly={true}
                                value={largeLanguageModel?.description || ''} />
                        </div>
                        {errors?.largeLanguageModel && <div className={html?.errorText}>{HtmlParser(errors?.largeLanguageModel || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.code?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.key} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.code?.[languageObj?.id]}
                                type='text'
                                onChange={(e) => setLlmModel(prev => ({ ...prev, [dbFields?.code]: e?.target?.value }))}
                                onFocus={() => setErrors(prev => ({ ...prev, code: '' }))}
                                placeholder={labels?.code?.[languageObj?.id]}
                                disabled={process?.showLoading}
                                value={llmModel?.code || ''} />
                        </div>
                        {errors?.code && <div className={html?.errorText}>{HtmlParser(errors?.code || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.description?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} style={{ top: '25px' }} />
                            <textarea className='form-control border-0 shadow-sm form-input-icon'
                                rows='2'
                                style={{ height: 'auto', paddingTop: '15px' }}
                                title={labels?.description?.[languageObj?.id]}
                                onChange={(e) => setLlmModel(prev => ({ ...prev, [dbFields?.description]: e?.target?.value }))}
                                placeholder={labels?.description?.[languageObj?.id]}
                                onFocus={() => setErrors(prev => ({ ...prev, description: '' }))}
                                disabled={process?.showLoading}
                                value={llmModel?.description || ''}>
                            </textarea>
                        </div>
                        {errors?.description && <div className={html?.errorText}>{HtmlParser(errors?.description || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.created?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'
                            id={controls?.pickers?.created?.id}
                            data-target-input='nearest'
                            data-target={`#${controls?.pickers?.created?.id}`}
                            data-toggle='datetimepicker'>
                            <i className={`${settings?.icons?.faFa?.calendar} position-absolute input-icon-left`} />
                            <input id={controls?.inputs?.created?.id}
                                type='text'
                                className='form-control border-0 shadow-sm form-input-icon datetimepicker-input'
                                onFocus={() => setErrors(prev => ({ ...prev, created: '' }))}
                                data-target={`#${controls?.pickers?.created?.id}`}
                                disabled={process?.showLoading} />
                        </div>
                        {errors?.created && <div className={settings?.html?.errorText}>{HtmlParser(errors?.created || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <div className='icheck-primary d-inline'>
                            <input type='checkbox'
                                id={'chkLlmModelId'}
                                checked={llmModel?.enabled || false}
                                onChange={(e) => setLlmModel(prev => ({ ...prev, [dbFields?.enabled]: e?.target?.checked }))}
                                disabled={process?.showLoading} />
                            <label htmlFor={'chkLlmModelId'} style={{ cursor: 'pointer' }}>
                                {labels?.enabled?.[languageObj?.id]}?
                            </label>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            type='submit'
                            disabled={process?.showLoading}>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`}></i>
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setShowModal(false)}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`}></i> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}